(function(){

var method;
var noop=function(){};
var methods=[
'assert','clear','count','debug','dir','dirxml','error',
'exception','group','groupCollapsed','groupEnd','info','log',
'markTimeline','profile','profileEnd','table','time','timeEnd',
'timeline','timelineEnd','timeStamp','trace','warn'];

var length=methods.length;
var console=window.console=window.console||{};

while(length--){
method=methods[length];


if(!console[method]){
console[method]=noop;
}
}


try{
if(!Object.prototype.__defineGetter__&&
Object.defineProperty({},'x',{get:function(){return!0}}).x){
Object.defineProperty(Object.prototype,'__defineGetter__',
{enumerable:!1,configurable:!0,
value:function(name,func)
{Object.defineProperty(this,name,
{get:func,enumerable:!0,configurable:!0});
}});
Object.defineProperty(Object.prototype,'__defineSetter__',
{enumerable:!1,configurable:!0,
value:function(name,func)
{Object.defineProperty(this,name,
{set:func,enumerable:!0,configurable:!0});
}});
}
}catch(defPropException){console.log('Error shimming __defineGetter__ and __defineSetter__')};

var BrowserDetect={
init:function(){
this.browser=this.searchString(this.dataBrowser)||'An unknown browser';
this.version=this.searchVersion(navigator.userAgent)||
this.searchVersion(navigator.appVersion)||
'an unknown version';
this.OS=this.searchString(this.dataOS)||'an unknown OS';
},
searchString:function(data){
for(var i=0;i<data.length;i++){
var dataString=data[i].string;
var dataProp=data[i].prop;
this.versionSearchString=data[i].versionSearch||data[i].identity;
if(dataString){
if(dataString.indexOf(data[i].subString)!=-1)
return data[i].identity;
}else
if(dataProp)
return data[i].identity;
}
},
searchVersion:function(dataString){
var index=dataString.indexOf(this.versionSearchString);
if(index==-1)return;
return parseFloat(dataString.substring(index+this.versionSearchString.length+1));
},
dataBrowser:[
{
string:navigator.userAgent,
subString:'OPR',
identity:'Opera',
versionSearch:'OPR'},

{
prop:window.opera,
identity:'Opera',
versionSearch:'Version'},

{
string:navigator.userAgent,
subString:'Vivaldi',
identity:'Vivaldi',
versionSearch:'Vivaldi'},

{
string:navigator.userAgent,
subString:'Chrome',
identity:'Chrome'},

{string:navigator.userAgent,
subString:'OmniWeb',
versionSearch:'OmniWeb/',
identity:'OmniWeb'},

{
string:navigator.vendor,
subString:'Apple',
identity:'Safari',
versionSearch:'Version'},

{
string:navigator.vendor,
subString:'iCab',
identity:'iCab'},

{
string:navigator.vendor,
subString:'KDE',
identity:'Konqueror'},

{
string:navigator.userAgent,
subString:'Firefox',
identity:'Firefox'},

{
string:navigator.vendor,
subString:'Camino',
identity:'Camino'},

{
string:navigator.userAgent,
subString:'Netscape',
identity:'Netscape'},

{
string:navigator.userAgent,
subString:'MSIE',
identity:'Explorer',
versionSearch:'MSIE'},

{
string:navigator.userAgent,
subString:'Trident',
identity:'Explorer',
versionSearch:'rv'},

{
string:navigator.userAgent,
subString:'Gecko',
identity:'Mozilla',
versionSearch:'rv'},

{
string:navigator.userAgent,
subString:'Mozilla',
identity:'Netscape',
versionSearch:'Mozilla'}],


dataOS:[
{
string:navigator.platform,
subString:'Win',
identity:'Windows'},

{
string:navigator.platform,
subString:'Mac',
identity:'Mac'},

{
string:navigator.userAgent,
subString:'iPhone',
identity:'iPhone/iPod'},

{
string:navigator.platform,
subString:'Linux',
identity:'Linux'}]};





BrowserDetect.init();


var browserName=BrowserDetect.browser;

if(browserName==='An unknown browser'){
console.log('Browser unknown, not appending browser-specific styles.');
return;
}

$('html').addClass('browser-'+browserName.replace(/\W+/g,'-').toLowerCase());



if(Function.prototype.name===void 0&&Object.defineProperty!==void 0||browserName==='Explorer'){
Object.defineProperty(Function.prototype,'name',{
get:function(){
var funcNameRegex=/function\s([^(]{1,})\(/;
var results=funcNameRegex.exec(this.toString());
return results&&results.length>1?results[1].trim():'';
},
set:function(value){}});

}

if("production"==='development'){

let oldMatches=Element.prototype.webkitMatchesSelector;
function newMatches(selector){
try{
return oldMatches.call(this,selector);
}catch(err){
return!1;
}
}
Element.prototype.webkitMatchesSelector=newMatches;
}

})();
//# sourceMappingURL=plugins.js.map
